export default {
  ADDRESS_DOSE_NOT_EXIST: "آدرس موجود نیست.",
  ADDRESS_INVALID: "آدرس نامعتبر است.",

  BANNER_NOT_EXIST: "هیچ بنری انتخاب نشده.",
  BANNER_SIZE_INVALID: "اندازه بنر مناسب نیست.",
  BANNER_FILE_INVALID: "فایل آپلود شده نامعتبر است.",
  
  BANNER_FILE_IS_HEAVY: "حجم فایل آپلود شده بیشتر از  ۱۵۰ کیلوبایت است.",

  ACTIVE_NOT_EXIST: "فعال بودن بنری موجود نیست.",
  ACTIVE_INVALID: "فعال بودن بنری نامعتبر است.",

  ADD_CAMPAIGN_SUCCESS: "کمپین اضافه شد.",
  ADD_CAMPAIGN_FAILED: "اضافه کردن کمپین با شکست روبرو شد.",

  ID_INVALID: "شماره نامعتبر است..",

  GET_CAMPAIGN_FAILED: "گرفتن کمپین با شکست روبرو شد.",

  DELETE_CAMPAIGN_FAILED: "حذف کمپین با شکست روبرو شد.",
  DELETE_CAMPAIGN_SUCCESS: "کمپین حذف شد.",

  EDIT_CAMPAIGN_FAILED: "ویرایش کمپین با شکست روبرو شد.",
  EDIT_CAMPAIGN_SUCCESS: "کمپین ویرایش شد.",
};
